// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"644":"31d6cfe0","864":"2fd2f1ce"}[chunkId] + ".chunk.css";
};